import { ratingConstants } from "../actions/constants/ratingConstant";

const ratingData = (
	state = { status: "", message: "" },
	action: any
) => {
	switch (action.type) {
		// Existing settings loaded when the page is opened
		case ratingConstants.RatingSettingGetRequest:
			return {
				...state,
				isLoading: true,
				isSuccess: false,
				isError: false,
				isDetailComplete: false,
			};
		case ratingConstants.RatingSettingGetSuccess:
			return {
				...state,
				isLoading: false,
				isSuccess: true,
				isError: false,
				isDetailError: false,
				isDetailComplete: true,
				settingInput: action.payload,
			};
		case ratingConstants.RatingSettingGetFailure:
			return {
				...state,
				isLoading: false,
				isSuccess: false,
				isError: true,
				isDetailError: true,
				isDetailComplete: true,
				status: action.payload,
			};

		case ratingConstants.RatingSettingUpdateRequest:
			return {
				...state,
				isLoading: true,
				isFormSubmit: true,
				isError: false,
				isSuccess: false,
				isUpdateComplete: false,
			};
		case ratingConstants.RatingSettingUpdateSuccess:
			return {
				...state,
				isLoading: false,
				isFormSubmit: false,
				isError: false,
				isSuccess: true,
				isUpdateComplete: true,
				status: action.payload?.status,
			};
		case ratingConstants.RatingSettingUpdateFailure:
			return {
				...state,
				isLoading: false,
				isFormSubmit: false,
				isSuccess: false,
				isError: true,
				isUpdateComplete: true,
				status: action.payload,
			};

		// Rating list - own flags so the list, filters and delete don't clash with the settings page
		case ratingConstants.RatingDashboardRequest:
			return {
				...state,
				isListLoading: true,
				isListComplete: false,
				isListError: false,
			};
		case ratingConstants.RatingDashboardSuccess:
			return {
				...state,
				isListLoading: false,
				isListComplete: true,
				isListError: false,
				dashboardData: action.payload,
			};
		case ratingConstants.RatingDashboardFailure:
			return {
				...state,
				isListLoading: false,
				isListComplete: true,
				isListError: true,
				status: action.payload,
			};

		case ratingConstants.RatingAppVersionsRequest:
			return {
				...state,
				isAppVersionError: false,
			};
		case ratingConstants.RatingAppVersionsSuccess:
			return {
				...state,
				isAppVersionError: false,
				appVersions: action.payload?.appVersions ?? [],
			};
		case ratingConstants.RatingAppVersionsFailure:
			return {
				...state,
				isAppVersionError: true,
				appVersions: [],
				status: action.payload,
			};

		case ratingConstants.RatingDeleteRequest:
			return {
				...state,
				isDeleteComplete: false,
				isDeleteError: false,
			};
		case ratingConstants.RatingDeleteSuccess:
			return {
				...state,
				isDeleteComplete: true,
				isDeleteError: false,
				status: action.payload?.status,
			};
		case ratingConstants.RatingDeleteFailure:
			return {
				...state,
				isDeleteComplete: true,
				isDeleteError: true,
				status: action.payload,
			};

		default:
			return state;
	}
};

export default ratingData;